import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await signInWithEmailAndPassword(auth, email, pw);
      navigate("/admin");
    } catch (e) { setErr("Login failed. Check your credentials."); }
    setLoading(false);
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">
          <img src="/logo.png" alt="Golden Gateway" style={{ height: 80, width: "auto", display: "block", margin: "0 auto 12px" }} />
          <h2 style={{ fontSize: 22 }}>Admin Login</h2>
          <p className="text-muted" style={{ fontSize: 13 }}>Golden Gateway Management Portal</p>
        </div>
        {err && <div className="alert alert-error">{err}</div>}
        <form onSubmit={submit}>
          <div className="form-group">
            <label className="form-label">Email</label>
            <input className="form-control" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </div>
          <div className="form-group">
            <label className="form-label">Password</label>
            <input className="form-control" type="password" value={pw} onChange={(e) => setPw(e.target.value)} required />
          </div>
          <button className="btn btn-primary" style={{ width: "100%", justifyContent: "center" }} disabled={loading}>
            {loading ? <span className="spinner"></span> : <><i className="ti ti-lock"></i> Sign In</>}
          </button>
        </form>
      </div>
    </div>
  );
}
